import { Box, Typography, Divider, Button } from '@mui/material';
import React from 'react';
import useDataNotifications from '../../hooks/useDataNotifications';
import Card from './Card';
import CardNotification from './CardNotification';
import NotificationsEmpty from './NotificationsEmpty';
import { useAuth } from '../../store/auth.store';
import { useTour } from '../../provider/TourGuide';

const List = () => {
    const { data, isLoading, readAllNotification } = useDataNotifications();
    const { enabledNotification } = useTour()
    const {user} = useAuth()
    const isDisabled = user?.permission?.permissionDetaileds[0]?.isServiceView &&
    user?.permission?.permissionDetaileds[0]?.isOrdersView

    return (
        <>
        <Box
            sx={{
                boxShadow: '0px 11px 24px 0px rgba(0, 51, 31, 0.10)',
            }}
        >
            <Box sx={{display:'flex', justifyContent:'space-between', padding:'5px 20px', alignItems:'center'}}>
                <Typography 
                    variant='h4' 
                    fontWeight={700} 
                    lineHeight={'28px'} 
                    fontSize={'20px'} 
                    color='#154D72' 
                >
                    התראות
                </Typography>
                <Button
                    onClick={() => readAllNotification()}
                >
                    קראתי הכל
                </Button>
            </Box>
            {enabledNotification &&
                <Box id="notification1">
                    <Card item={
                        {
                            id:1,
                            title:'הזמנה מס׳ SO24004XXX סופקה!',
                            description:"הוזמנה בתאריך 20.12.2024 לרמת גן, שלום עליכם 53",
                            area:"200",
                            userExtId:'123123',
                            user:user!,
                            read:false,
                            createdAt:"2025-04-20",
                            documentType:"order",
                            documentNumber:"SO24004XXX",
                            imageLink:""
                        }
                    } />
                    <Divider/>
                </Box>
            }
            {isLoading ? (
                [...Array(5)].map((_, index) => (
                    <Box key={index}>
                        <CardNotification />
                        <Divider/>
                    </Box>
                ))
            ) : !data?.length ? (
                // isDisabled === both orders & service views granted. With permission
                // and nothing to show -> "no notifications yet"; without it -> a
                // designed "no permission" state (replaces the old bare line that sat
                // 200px down and read as a blank page).
                <NotificationsEmpty variant={isDisabled ? 'empty' : 'noPermission'} />
            ) : (
                data.map((item) => (
                    <Box key={item.id}>
                        <Card item={item} />
                        <Divider/>
                    </Box>
                ))
            )}

        </Box>
        </>

    );
};

export default List;
